
<mat-form-field class="gruppevelger">
  <mat-label>{{ "Velg gruppe å importere fra"|translate }}</mat-label>
  <velg-gruppe [skjemakontroll]="valgtGruppe" [grupper]="tilgjengeligeGrupper()"/>
</mat-form-field>

@if(valgtGruppe.value != null){
  <table class="invitasjonerskjema e2e-invitasjoner">
    <medlem-importer-skjemaoverskrifter [skjema]="skjema.controls.medlemmer" [alleValgt]="alleValgt()" [ingenValgt]="ingenValgt()" (endreAlle)="endreAlle()"/>
    @if(skjema.controls.medlemmer.controls.length > 0){
    <thead>
      <tr>
        <td></td>
        <td colspan="8" class="grupperingstittel">{{'Medlemmer som har godtatt invitasjon'|translate}}</td>
      </tr>
    </thead>
    <tbody>
      @for(linje of skjema.controls.medlemmer.controls; track linje){
        <medlem-importer-skjemalinje [skjema]="linje" [medlemsroller]="medlemsroller()"/>
      }
    </tbody>
    }
    @if(skjema.controls.invitasjoner.controls.length > 0){
    <thead>
      <tr>
        <td></td>
        <td colspan="8" class="grupperingstittel">{{'Inviterte medlemmer'|translate}}</td>
      </tr>
    </thead>
    <tbody>
      @for(linje of skjema.controls.invitasjoner.controls; track linje){
        <medlem-importer-skjemalinje [skjema]="linje" [medlemsroller]="medlemsroller()"/>
      }
    </tbody>
    }
    @if(skjema.controls.deaktiverte.controls.length > 0){
      @if(visDeaktiverte()){
      <thead>
        <tr>
          <td></td>
          <td colspan="8" class="grupperingstittel">{{'Deaktiverte medlemmer'|translate}}</td>
        </tr>
      </thead>
      <tbody>
        @for(linje of skjema.controls.deaktiverte.controls; track linje){
          <medlem-importer-skjemalinje [skjema]="linje" [medlemsroller]="medlemsroller()"/>
        }
      </tbody>
      } @else {
      <tfoot>
        <tr>
          <td></td>
          <td colspan="8">
            <a (click)="visDeaktiverte.set(true)">{{'Vis {antall} medlemmer med stengt tilgang'|translate:{antall:skjema.controls.deaktiverte.controls.length} }}</a>
          </td>
        </tr>
      </tfoot>
      }
    }
  </table>
}
